// Mirrors: App\Enums\PurchaseRequirementTypes (core)
export const PurchaseRequirementType = Object.freeze({
    NONE: 0,
    CHARACTER: 1,
    DIVISION: 2,
    GUILD_VIP_LEVEL: 3,
    SUBSCRIBER: 4,
});
